<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M10.5 22a2 2 0 0 1-1.2-.4l-.7-1-.6-2-.5-1-.8-1q-.8-.9-1.3-2.1a7 7 0 0 1 1.3-7l.8-1.2.5-1 .6-1.9q.2-.6.7-1a2 2 0 0 1 1.2-.4h3q.6 0 1.2.4t.7 1l.6 2 .5 1 .8 1q.8.9 1.3 2.1a7 7 0 0 1-1.3 7l-.8 1.1-.5 1-.6 2-.7 1a2 2 0 0 1-1.2.4zm1.5-5q2.1 0 3.5-1.5Q17 14.1 17 12t-1.5-3.5T12 7 8.5 8.5Q7 9.9 7 12t1.5 3.5T12 17"
    />
    <path
      d="M12.7 8.8a1 1 0 0 0-1.7.7v3l.3.7 1.4 1.5a1 1 0 0 0 1.5-1.5L13 12.1V9.5z"
    />
  </svg>
</template>
